import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgMinus(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 4",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M.132 1.923h19.582",
    stroke: "inherit",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }));
}
const MemoSvgMinus = React.memo(SvgMinus);
export default MemoSvgMinus;